import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalConfirmComponent } from '../shared-layout/ngbd-modal-confirm/ngbd-modal-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  constructor(private modalService: NgbModal) {}

  open(options: {
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    size?: 'sm' | 'lg' | 'xl';
    centered?: boolean;
    confirmButtonClass?: string;
  }): Promise<boolean> {
    const modalOptions: NgbModalOptions = {
      size: options.size,
      centered: options.centered,
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(NgbdModalConfirmComponent, modalOptions);
    const instance = modalRef.componentInstance;

    instance.title = options.title;
    instance.message = options.message || 'Are you sure?';
    instance.confirmText = options.confirmText || 'Yes';
    instance.cancelText = options.cancelText || 'No';
    instance.confirmButtonClass = options.confirmButtonClass || 'btn-danger';

    return modalRef.result.then(
      (result) => result === true,
      () => false
    );
  }
}
